import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-text',
  templateUrl: './search-text.component.html',
  styleUrls: ['./search-text.component.scss']
})
export class SearchTextComponent {
  @Input() public control: FormControl = new FormControl<string | null>(null);
  @Input() public label!: string;
  @Output() search = new EventEmitter<string>();

  constructor() {  
  }

  onSearch() {
    this.search.emit(this.control.value);
  }

  onReset() {
    this.control.setValue(null);

    this.onSearch();
  }
}
